@if (target() === urlTarget.BLANK) {
  <i class="pi pi-arrow-up-right arrow-up-right align-self-center"></i>
}
